import {ReactComponent as Icon} from "./captainFemale.svg"

type StopwatchIconProps = {
	className?: string;
};

const CaptainFemaleIcon: React.FunctionComponent<StopwatchIconProps> = ({className}) => {
	return <Icon className={className}/>;
};

export default CaptainFemaleIcon;